import type { Context } from 'react'
import { useContext } from 'react'
import store from 'storeContext'
import type { SetPositionContextValueType } from 'storeContext/contexts/setPosition'

export const useSetPositionContext = () =>
  useContext(store.SetPositionContext as unknown as Context<SetPositionContextValueType>)
